import {
  DEFAULT_SALARY_PERIOD,
  salaryPeriodSuffixMap,
} from './salaryPeriodOptions';

type FormatSalaryRangeParams = {
  minPay?: string | number | null;
  maxPay?: string | number | null;
  currency?: string | number | null;
  salaryPeriod?: string;
};

const normalizeSalaryValue = (value?: string | number | null) => {
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value.toString().trim();
  }
  return '';
};

export const formatSalaryRange = ({
  minPay = '',
  maxPay = '',
  currency = '',
  salaryPeriod = DEFAULT_SALARY_PERIOD,
}: FormatSalaryRangeParams) => {
  const normalizedMinPay = normalizeSalaryValue(minPay);
  const normalizedMaxPay = normalizeSalaryValue(maxPay);
  const normalizedCurrency = normalizeSalaryValue(currency);
  const normalizedSalaryPeriod =
    typeof salaryPeriod === 'string' && salaryPeriod.trim().length > 0
      ? salaryPeriod.trim()
      : DEFAULT_SALARY_PERIOD;

  if (!normalizedMinPay && !normalizedMaxPay) {
    return '';
  }

  const range = [normalizedMinPay, normalizedMaxPay].filter(Boolean).join('-');
  const baseLabel = [range, normalizedCurrency].filter(Boolean).join(' ');
  const cadence =
    salaryPeriodSuffixMap[normalizedSalaryPeriod] || normalizedSalaryPeriod;

  return cadence ? `${baseLabel} / ${cadence}` : baseLabel;
};
